<!--
Copyright 2026 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information.
-->
<crucible-dialog
  [dialogTitle]="(data.competencyFramework.id ? 'Edit' : 'Create') + ' Competency Framework'"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.competencyFramework !== undefined && data.competencyFramework !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input
              type="text"
              title="The Name of the Competency Framework"
              matInput
              placeholder="Name (required)"
              [(ngModel)]="data.competencyFramework.name">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Version</mat-label>
            <input
              type="text"
              title="The Version of the Competency Framework"
              matInput
              placeholder="Version"
              [(ngModel)]="data.competencyFramework.version">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Source</mat-label>
            <input
              type="text"
              title="The Source of the Competency Framework (e.g. NICE, DCWF)"
              matInput
              placeholder="Source (e.g. NICE, DCWF)"
              [(ngModel)]="data.competencyFramework.source">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <textarea
              matInput
              rows="4"
              title="The Description of the Competency Framework"
              placeholder="Description"
              [(ngModel)]="data.competencyFramework.description">
            </textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Proficiency Scale</mat-label>
            <mat-select [(ngModel)]="data.competencyFramework.defaultProficiencyScaleId">
              <mat-option [value]="null">None</mat-option>
              @for (scale of proficiencyScales; track scale.id) {
              <mat-option [value]="scale.id">{{ scale.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</crucible-dialog>
